import React, { useEffect } from 'react';
import {
  Button, Form, Input, Modal,
} from 'antd';
import PropTypes from 'prop-types';

const BoardFormModal = ({
  isOpen = false,
  editingBoard = null,
  onSubmit = () => {},
  onClose = () => {},
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue(editingBoard || { name: '' });
    }
  }, [isOpen, editingBoard, form]);

  const handleFinish = (values) => {
    onSubmit(values);
  };

  return (
    <Modal
      title={editingBoard ? 'Редагувати дошку' : 'Створити дошку'}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
    >
      <Form
        form={form}
        onFinish={handleFinish}
        layout="vertical"
        preserve={false}
      >
        <Form.Item
          name="name"
          label="Назва"
          rules={[{ required: true, message: 'Введіть назву дошки' }]}
        >
          <Input placeholder="Назва дошки" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {editingBoard ? 'Зберегти' : 'Створити'}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

BoardFormModal.propTypes = {
  isOpen: PropTypes.bool,
  editingBoard: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

export default BoardFormModal;
